import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { css } from 'twin.macro';
import { fetchWrapper, getTeamIdFromURL } from '../../../../_helpers';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';
import { teamSettingsApi } from '@/_services/api/teamSettings';
import LoadingSpiner from '@/_elements/LoadingSpiner';
import { VscLoading } from 'react-icons/vsc';
const Colorbox = styled.div`
    border: 1px solid gray;
    width: 30px;
    height: 30px;
    &.verifed {
        background: #a7d5d8;
    }
`;

const VisitLabelSettings = () => {
    const teamId = getTeamIdFromURL();

    const [defaultLabels, setDefaultLabels] = useState({});
    const [labelKeys, setLabelKeys] = useState([]);

    const [labels, setLabels] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isBusy, setIsBusy] = useState(false);
    const getDefaultLabels = async () => {
        try {
            setIsLoading(true);
            const response = await fetchWrapper.get('label');
            const apiLabels = response?.labels?.visits || {};
            setDefaultLabels(apiLabels);
            const keys = Object.keys(apiLabels);
            setLabelKeys(keys);
            setLabels(apiLabels);
            const { visitLabels = {} } = await teamSettingsApi.getTeamSettings(teamId);

            (keys || []).forEach((key) => {
                const value = visitLabels[key] || key;
                setLabels((prev) => ({ ...prev, [key]: value }));
            });
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        getDefaultLabels();
    }, []);

    const handleLabelChange = (key) => (event) => {
        setLabels({
            ...labels,
            [key]: event.target.value,
        });
    };

    const handleSave = async () => {
        setIsBusy(true);
        try {
            await teamSettingsApi.updateVisitLabels(teamId, labels);
            toast.success('Visit labels updated successfully');
        } catch (error) {
            console.error('Failed to update visit labels:', error);
            toast.error(error.message || 'Failed to update visit labels');
        } finally {
            setIsBusy(false);
        }
    };

    const handleReset = async () => {
        setIsBusy(true);
        try {
            await teamSettingsApi.deleteVisitLabels(teamId);
            toast.success('Visit labels reset successfully');
        } catch (error) {
            toast.error(error.message || 'Failed to reset visit labels');
            console.error('Failed to reset visit labels:', error);
        } finally {
            setIsBusy(false);
            await getDefaultLabels();
        }
    };

    if (isLoading) {
        return (
            <div className="text-center p-4">
                <LoadingSpiner size={42} height={200} />
                <p className="mt-2">Loading settings...</p>
            </div>
        );
    }

    return (
        <div
            css={css`
                margin-bottom: 1.5rem;
            `}
        >
            <div className="mb-2 mt-2">
                <h2>Visit Label Settings</h2>
                <p className="text-muted mb-4">
                    These labels will be displayed throughout the application for all team members. Changes will take
                    effect immediately after saving.
                </p>
            </div>

            <Row>
                {labelKeys &&
                    labelKeys.map((key) => (
                        <Col xs={12} sm={6} md={4} key={key} className="mb-3">
                            <Form.Group>
                                <div className="d-flex pb-1 pr-1 align-items-center">
                                    <Colorbox
                                        css={css`
                                            background: ${defaultLabels[key]};
                                        `}
                                    />
                                    <div className="ml-2">
                                        <span className="mr-1">:</span>
                                        {key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
                                    </div>
                                </div>

                                <Form.Control
                                    type="text"
                                    name={key}
                                    value={(labels || {})[key]}
                                    onChange={handleLabelChange(key)}
                                    placeholder={`Enter ${key.replace(/_/g, ' ')} label...`}
                                />
                            </Form.Group>
                        </Col>
                    ))}
            </Row>

            <div
                css={css`
                    display: flex;
                    justify-content: flex-end;
                    margin-top: 1.5rem;
                    gap: 0.75rem;
                `}
            >
                <Button variant="primary" onClick={handleSave} disabled={isBusy}>
                    {isBusy && <VscLoading className="spin mr-2" size={16} />}
                    Save Changes
                </Button>
                <Button variant="outline-secondary" onClick={handleReset} disabled={isBusy}>
                    {isBusy && <VscLoading className="spin mr-2" size={16} />}
                    Reset to Defaults
                </Button>
            </div>
        </div>
    );
};

export default VisitLabelSettings;
